import React from 'react';
import { SharedResourcesList } from './SharedResources';

const SharedTasks = () => {
  return (
    <SharedResourcesList
      resourceCategory={null}
      allowedResourceTypes={['TASK']}
      resourceNameColumnLabel="Task name"
      showTypeColumn={false}
      successConfig={{
        message: 'The shared task has been added to your Tasks.',
        redirectPath: '/#/tasks',
        buttonLabel: 'Go to Tasks',
      }}
      rejectConfig={{
        title: 'Reject shared task?',
        message: 'Once rejected the shared task will be lost forever. Are you sure you want to continue?',
      }}
    />
  );
};

export default SharedTasks;

